// extracted by mini-css-extract-plugin
export default {"dropdown":"WqEmXbGN","menu":"qT8TtbnA"};